import { api } from '@/core/api/';

const baseApiURL = 'api/student';

export const getStudentHistory = () => {
  return api.get(`${baseApiURL}/historysearch`);
};

export const getImpediments = async () => {
  return api.get(`${baseApiURL}/impediments`);
};

export const getAdvancedSearch = async (payload) => {
  return api.get(`${baseApiURL}/studentadvancedsearch`, {
    params: {
      ...payload,
    },
  });
};

export const getBySie = async (studentSieId, webServiceSearchOnly = false) => {
  let uri = `${baseApiURL}/studentbysie/${studentSieId}`;

  if (webServiceSearchOnly) uri += `&searchMode=2`;

  return api.get(uri);
};

export const sendReadAlert = async () => {};

export const getStudentDetails = async (studentSie, syncFlag) => {
  return api.get(`${baseApiURL}/studentdetails`, {
    params: {
      studentSie,
      syncFlag,
    },
  });
};

export const saveHistorySearch = async (studentSieId) => {
  return api.post(`${baseApiURL}/savehistorysearch/${studentSieId}`);
};

export const getStudentDetailsWithEnrollmentSchool = async (studentSieId) => {
  return api.get(`${baseApiURL}/studentdetailswithenrollmentschool`, {
    params: {
      studentSieId,
    },
  });
};

export const getStudentPeiHistory = async (
  studentSieId,
  year,
  pageIndex,
  pageSize
) => {
  return api.get(`${baseApiURL}/peihistory`, {
    params: {
      studentSieId,
      year,
      pageIndex,
      pageSize,
    },
  });
};

export const getStudentStatuses = async (statusId) => {
  return api.get(`${baseApiURL}/studentstatuses`, {
    params: {
      statusId,
    },
  });
};

export const getStudentTherapies = async (studentSieId) => {
  return api.get(`${baseApiURL}/studenttherapies`, {
    params: {
      studentSieId,
    },
  });
};
export const saveStudentDiagnosis = (payload) =>
  api.post(`${baseApiURL}/diagnosis`, payload);

export const getLastDiagnosis = (studentSieId, disciplineTypeId) =>
  api.get(`${baseApiURL}/lastdiagnosis/${studentSieId}/${disciplineTypeId}`);

export const searchDiagnosticsExcludingStudent = (studentSieId, term = '') =>
  api.get(`${baseApiURL}/${studentSieId}/diagnostics-excluding`, {
    params: { term },
  });
